var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logs-component"},[_c('ul',_vm._l((_vm.logs),function(log){return _c('li',[_c('h3',[_vm._v(_vm._s(log.created_by.name)+"\n                "),_c('small',[_vm._v(_vm._s(log.created_at))])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(log.text)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }